<template>
    <div class="index" style="margin-bottom: 40px;">
        <div style="width: 1200px; margin: 0 auto;">
            <div class="top_title">
                <!-- 左侧位置 -->
                <div class="top_title_left">
                    <div class="left_icon">
                        <img src="../../assets/xiangning/news_detail/location.png" alt="">
                    </div>
                    <div class="left_text">
                        当前位置：红色云展厅>详情
                    </div>
                </div>
                <div class="right_back">
                    <div class="right_back_icon"><img src="../../assets/xiangning/news_detail/back.png" alt=""></div>
                    <div @click="$router.go(-1)">返回</div>
                </div>

            </div>
            <!-- 文章内容 -->
            <div class="artical_content">
                <!-- 上方文章标题 -->
                <div class="artical_content_title">
                    <div class="artical_content_title_main">
                        {{ title }}
                    </div>

                </div>
                <div class="video_box" v-if="sz_img!=''||video_url!=''">
                    <img v-if="sz_img!=''" :src="sz_img" alt="">
                    <video controls="noDownload" v-if="video_url!=''" :src="video_url"></video>
                </div>
                <!-- 下方文章内容 -->
                <div v-html="content" class="artical_content_main_text">
                     
                </div>
                <!-- 音频播放器 -->
                <div v-if="audioUrl!=''" class="audio_play">
                    <audio ref="audio" id="audio" :src="audioUrl" @pause="onPause" @play="onPlay">
                    </audio>
                    <div class="audio_contrals">
                        <div class="audio_contrals_change">
                            <div @click="changAudioindex('pre')" class="audio_contrals_pre"><img
                                    src="../../assets/zyjh/pre.png" alt=""></div>
                            <div @click="pause" v-if="audio.playing" class="audio_contrals_parse"><img
                                    src="../../assets/zyjh/parse.png" alt=""></div>
                            <div @click="play" v-if="!audio.playing" class="audio_contrals_parse"><img
                                    src="../../assets/zyjh/audio_play.png" alt=""></div>
                            <div @click="changAudioindex('next')" class="audio_contrals_pre">
                                <img src="../../assets/zyjh/next.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

import { shouye } from '@/axios';
import {
	Message
} from 'element-ui'
export default {
    data() {
        return {

            getdata: {
                id: this.$route.query.id,
                type:this.$route.query.type,

            },
            index: 0,


            content: '',
            title: '',
            sz_img: '',
            audioUrl: '',
            video_url: '',

            audio: {
                // 播放状态
                playing: false,
                // 静音状态
                // muted: false,
                // 音频当前播放时长
                currentTime: 0,
                // 音量
                volume: 1,
                // 音频最大播放时长
                maxTime: 0
            },
            audioList: [],
            audioUrl: 'https://people.5cy.com/p3/sz/szmy_mp3/xxdt0165.mp3',
            audioTitle: '',
            edgeLength: 30,
            Audioindex: 0

        }
    },
    // components:{ Title },
    methods: {
        changAudioindex(type) {
            
           if (type=='pre') {
            Message({
				message: '当前已是第一个音频',
				type: 'warning'
			})
           }else{
            Message({
				message: '当前已是最后一个音频',
				type: 'warning'
			})
           }

       
        },
        // 播放音频
        play() {

            this.$refs.audio.play()
        },
        // 暂停音频
        pause() {
            this.$refs.audio.pause()
        },
        // 当音频播放
        onPlay() {
            console.log('视频播放了');
            this.audio.playing = true
        },
        // 当音频暂停
        onPause() {
            console.log('视频暂停了');
            this.audio.playing = false
        },

        handleScroll() {
            let that = this
            // 判断页面的滚动距离如果大于500展示回到顶部按钮
            if (window.pageYOffset > 500) {
                that.isShow = true
            } else {
                that.isShow = false
            }
        },
        toTopHandle() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },

        // 获取详情
        getDetail() {
            let that = this
            shouye.hsyztDetail(that.getdata).then((res) => {
                if (res.code == 200) {

                    that.title = res.data.title
                    that.content = res.data.content
                    that.sz_img = res.data.sz_img
                    that.audioUrl = res.data.audio_url
                    that.video_url = res.data.video_url

                }
            })
        }




    },
    mounted() {

        this.getDetail()

    },



}
</script>

<style lang="scss" scoped>
.top_title {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.audio_play {
    
    height: 80px;
    width: 720px;
    border-radius: 20px;
    background-image: url(../../assets/zyjh/aduio_bg.png);
    background-size: 100% 100%;
    color: #fff;
    box-sizing: border-box;
    border: 3px solid #C9171E;
    margin: 20px auto;

    .audio_contrals {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;

        .audio_contrals_change {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .audio_contrals_pre {
                width: 48px;
                height: 48px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .audio_contrals_parse {
                width: 48px;
                height: 48px;
                margin: 0 40px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }


    }
}


.top_title_left {
    display: flex;
    align-items: center;
}

.left_icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

img {
    width: 100%;
    height: 100%;
}

.left_text {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    height: 20px;
    line-height: 20px;
}

.right_back {
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 10px;
    cursor: pointer;
}

.right_back:hover {
    font-weight: 800;
    color: #C9010A;
}

.right_back_icon {
    height: 10px;
    width: 12px;
    margin-right: 5px;
}

.right_back_icon img {
    height: 100%;
    width: 100%;
}

.artical_content {
    border-bottom: 1px solid #D8D8D8;
    .video_box{
        width: 100%;
        height: 315px;
        display: flex;
        justify-content: center;
        gap: 20px;
        margin: 40px auto;
        img{
            width: 560px;
            height: 315px;
        }
        video{
            width: 560px;
            height: 315px;
        }
    }
}

.artical_content_title {
    margin-top: 30px;
    padding: 0 140px;
    position: relative;
}

.artical_content_title_main {
    width: 100%;
    white-space: wrap;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
    margin-bottom: 10px;
}

.artical_content_title_time {
    font-family: PingFangSC-Regular;
    text-align: center;
}

.artical_content_title_time span {
    margin-right: 10px;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
}

.artical_content_main_text {
    width: 100%;
   
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    line-height: 28px;
    text-align: justify;
    letter-spacing: 0em;
    color: #000000;
    margin:20px auto;
}

.artical_content_main_text p {
    text-indent: 28px;
    font-family: PingFangSC-Regular;
    /* font-size: 14px; */
    font-weight: normal;
    /* line-height: 28px; */
    text-align: justify;
    letter-spacing: 0em;

    color: #000000;
    margin-bottom: 28px;
}

.artical_content_main_text img {
    display: block;
    max-width: 840px;
    margin: 0 auto 28px auto;

}

.bottom_download {
    width: 100%;
    padding-top: 20px;
    display: flex;
}

.bottom_download_title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #1C76FD;
}

.bottom_download_right_item {
    display: flex;
    height: 16px;
    margin-bottom: 16px;

}

.bottom_download_right_item_icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
}

.bottom_download_right_item_name a {
    text-decoration: none;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    display: flex;
    align-items: center;
    letter-spacing: 0em;
    color: #1C76FD;
}

.backTop {
    width: 70px;
    height: 70px;
    position: fixed;
    top: 500px;
    right: 224px;
    /* display: none; */
}

.backTop img {
    width: 70px;
    height: 70px;
}

.changeFontSize {
    z-index: 99;
    position: absolute;
    top: 3PX;
    right: 0;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #1C76FD;
    display: flex;
    align-items: center;
}

.changeFontSize_A {
    display: inline-block;
    width: 17px;
    height: 28px;
    margin-left: 10px;
}
</style>
